/**
 * App layout - ResizableLayout hosts all authenticated surfaces including /people/:id.
 */

import { ResizableLayout } from './resizable-layout'
import { testIds } from '@/lib/test-ids'

export function AppLayout() {
  return (
    <div className="h-full min-h-0" data-testid={testIds.appLayout.container}>
      <ResizableLayout />
    </div>
  )
}
